import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { v4 as UUIDV4 } from 'uuid';
import { RadioGroup } from '@pwc/pwc-deals-ui';
import SVGScaling from './components/SVGScaling';
import styles from './styles.module.scss';

export enum EContentFormats {
  Image = 'image',
  WebTable = 'web-table',
}

interface IITems {
  readonly excel?: {
    readonly cellRange?: {
      readonly id: number;
    };
  };
}

interface IProps {
  readonly initialValueRadio: EContentFormats;
  readonly items?: IITems;
  readonly isDisabled?: boolean;
  readonly onChangeValueRadio?: (x: {
    readonly current: EContentFormats;
    readonly items?: IITems;
    readonly previous: EContentFormats;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => any;
  readonly overrideValueRadio?: EContentFormats;
  readonly propsRoot?: React.ComponentProps<'div'>;
  readonly propsSVGScaling?: Omit<
    React.ComponentProps<typeof SVGScaling>,
    'isDarkMode'
  >;
  readonly showFormatSwitcher?: boolean;
  readonly useLegacyFormatSwitcher?: boolean;
}

const LibraryItemCardWidgetOptions: React.FC<IProps> = ({
  initialValueRadio,
  items,
  isDisabled,
  onChangeValueRadio,
  overrideValueRadio,
  propsRoot,
  propsSVGScaling,
  useLegacyFormatSwitcher,
}) => {
  const [valueRadio, setValueRadio] = useState(initialValueRadio);

  const constants = {
    componentID: UUIDV4(),
  };

  useEffect(() => {
    if (onChangeValueRadio && valueRadio !== initialValueRadio) {
      onChangeValueRadio({
        current: valueRadio,
        items,
        previous: initialValueRadio,
      });
    }
  }, [valueRadio, initialValueRadio, onChangeValueRadio, items]);

  const handleFieldOnChange: React.ComponentProps<
    typeof RadioGroup
  >['field']['onChange'] = ({ target: { value } }) => {
    setValueRadio(value as EContentFormats);
  };
  const getters = {
    valueRadio: () => {
      return overrideValueRadio || valueRadio;
    },
  };

  return (
    <div
      {...propsRoot}
      className={cn(
        'ck-editor-no-override-styles',
        styles.root,
        propsRoot?.className
      )}
    >
      {!useLegacyFormatSwitcher && (
        <RadioGroup
          className="ck-editor-no-override-styles"
          classNameLabelRadioGroup={cn(
            'ck-editor-no-override-styles',
            styles.radioLabel
          )}
          disabled={isDisabled}
          direction="row"
          field={{
            name: `ComponentTop-DraggableLibraryItemCard-${constants.componentID}`,
            onChange: handleFieldOnChange,
            value: getters.valueRadio(),
          }}
          label="Display as:"
          options={[
            {
              label: 'Image',
              value: 'image',
            },
            {
              label: 'Web table',
              value: 'web-table',
            },
          ]}
        />
      )}

      {getters.valueRadio() === 'image' && (
        <SVGScaling isDisabled={isDisabled} {...propsSVGScaling} />
      )}
    </div>
  );
};

export default LibraryItemCardWidgetOptions;
